module.exports = __webpack_public_path__ + "media/images/prepaid-bundles-banner-f06c6581afc30e2e817be666dddc7971.jpg";